(() => {
  if (window.__redprintwareProductProLoaded) return;
  window.__redprintwareProductProLoaded = true;

  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let stickyFrame = 0;

  async function handleBuyNow(button) {
    if (button.disabled || button.classList.contains('loading')) return;

    const productFormElement = button.closest('product-form');
    const form = productFormElement?.querySelector('form[data-type="add-to-cart-form"]');
    const nativeSubmit = productFormElement?.querySelector('[name="add"]');
    if (!form || nativeSubmit?.disabled || nativeSubmit?.getAttribute('aria-disabled') === 'true') return;

    const spinner = button.querySelector('.loading__spinner');
    button.disabled = true;
    button.classList.add('loading');
    spinner?.classList.remove('hidden');

    try {
      const formData = new FormData(form);
      const response = await fetch(window.routes?.cart_add_url || `${rootUrl()}cart/add.js`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        body: formData,
      });

      const payload = await response.json();
      if (!response.ok || payload?.status) {
        throw new Error(payload?.description || payload?.message || 'Unable to start checkout.');
      }

      window.location.assign(`${rootUrl()}checkout`);
    } catch (error) {
      productFormElement?.handleErrorMessage?.(error.message || 'Unable to start checkout.');
      button.disabled = false;
      button.classList.remove('loading');
      spinner?.classList.add('hidden');
    }
  }

  function setStickyButtonState(bar, available, label) {
    if (!bar) return;
    const input = bar.querySelector('[data-rpw-sticky-variant-id]');
    const button = bar.querySelector('.rpw-sticky-atc__button');
    const buttonLabel = bar.querySelector('[data-rpw-sticky-button-label]');

    if (input) input.disabled = !available;
    if (button) {
      button.disabled = !available;
      if (available) button.removeAttribute('aria-disabled');
      else button.setAttribute('aria-disabled', 'true');
    }
    if (label && buttonLabel) buttonLabel.textContent = label;
  }

  function syncStickyBar(sectionId, sourceDocument, variant) {
    if (!sectionId) return;
    const bar = document.querySelector(`#RedprintwareStickyAtc-${CSS.escape(String(sectionId))}`);
    if (!bar) return;

    const sourceBar = sourceDocument?.querySelector?.(`#RedprintwareStickyAtc-${CSS.escape(String(sectionId))}`);
    const hiddenVariant = bar.querySelector('[data-rpw-sticky-variant-id]');
    const select = bar.querySelector('[data-rpw-sticky-variant-select]');

    if (variant?.id && hiddenVariant) {
      hiddenVariant.value = variant.id;
      hiddenVariant.disabled = !variant.available;
    }
    if (variant?.id && select) select.value = String(variant.id);

    if (sourceBar) {
      const currentPrice = bar.querySelector('[data-rpw-sticky-price-group]');
      const freshPrice = sourceBar.querySelector('[data-rpw-sticky-price-group]');
      if (currentPrice && freshPrice) currentPrice.innerHTML = freshPrice.innerHTML;

      const currentMedia = bar.querySelector('[data-rpw-sticky-media]');
      const freshMedia = sourceBar.querySelector('[data-rpw-sticky-media]');
      if (currentMedia && freshMedia) currentMedia.innerHTML = freshMedia.innerHTML;

      const freshLabel = sourceBar.querySelector('[data-rpw-sticky-button-label]')?.textContent?.trim();
      setStickyButtonState(bar, Boolean(variant?.available), freshLabel);
    } else {
      setStickyButtonState(bar, Boolean(variant?.available));
    }

    syncStickyQuantity(sectionId);
  }

  function syncStickyQuantity(sectionId) {
    const productRoot = document.querySelector(`#MainProduct-${CSS.escape(String(sectionId))}`);
    const bar = document.querySelector(`#RedprintwareStickyAtc-${CSS.escape(String(sectionId))}`);
    if (!productRoot || !bar) return;
    const mainQty = productRoot.querySelector('.product-form__quantity .quantity__input');
    const stickyQty = bar.querySelector('[data-rpw-sticky-quantity]');
    if (stickyQty) stickyQty.value = mainQty?.value || '1';
  }

  function selectMainVariantFromSticky(select) {
    const bar = select.closest('[data-rpw-sticky-atc]');
    const sectionId = bar?.dataset.sectionId;
    const productRoot = sectionId
      ? document.querySelector(`#MainProduct-${CSS.escape(String(sectionId))}`)
      : null;
    const selectedOption = select.selectedOptions?.[0];
    const optionValue = selectedOption?.dataset.optionValue;
    if (!productRoot || !optionValue) return;

    const nativeVariantSelects = productRoot.querySelector('variant-selects');
    if (!nativeVariantSelects) return;

    const radios = Array.from(nativeVariantSelects.querySelectorAll('input[type="radio"]'));
    const matchingRadio = radios.find((input) => input.value === optionValue);
    if (matchingRadio) {
      if (!matchingRadio.checked) matchingRadio.checked = true;
      setStickyButtonState(bar, false);
      matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const nativeSelect = nativeVariantSelects.querySelector('select');
    if (nativeSelect) {
      nativeSelect.value = optionValue;
      setStickyButtonState(bar, false);
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function updateStickyVisibility() {
    stickyFrame = 0;
    document.querySelectorAll('[data-rpw-sticky-atc]').forEach((bar) => {
      const sectionId = bar.dataset.sectionId;
      const productRoot = document.querySelector(`#MainProduct-${CSS.escape(String(sectionId))}`);
      const anchor = productRoot?.querySelector(`#ProductSubmitButton-${CSS.escape(String(sectionId))}`);
      if (!anchor) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        return;
      }

      // Only show once the primary purchase CTA has actually scrolled above
      // the viewport. This prevents a sticky bar from appearing too early on mobile.
      const shouldShow = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', shouldShow);
      bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    });
  }

  function requestStickyVisibilityUpdate() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(updateStickyVisibility);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.rpw-buy-now-button');
    if (!button) return;
    event.preventDefault();
    handleBuyNow(button);
  });

  document.addEventListener('change', (event) => {
    const stickySelect = event.target.closest?.('[data-rpw-sticky-variant-select]');
    if (stickySelect) {
      selectMainVariantFromSticky(stickySelect);
      return;
    }

    const quantityInput = event.target.closest?.('.redprintware-product-pro .product-form__quantity .quantity__input');
    if (quantityInput) {
      const productRoot = quantityInput.closest('.redprintware-product-pro');
      if (productRoot?.dataset.section) syncStickyQuantity(productRoot.dataset.section);
    }
  });

  window.addEventListener('scroll', requestStickyVisibilityUpdate, { passive: true });
  window.addEventListener('resize', requestStickyVisibilityUpdate, { passive: true });
  document.addEventListener('DOMContentLoaded', requestStickyVisibilityUpdate);
  document.addEventListener('shopify:section:load', requestStickyVisibilityUpdate);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const root = data?.event?.target?.closest?.('.redprintware-product-pro');
      root?.querySelectorAll('.rpw-buy-now-button').forEach((button) => (button.disabled = true));

      const sectionId = root?.dataset.section;
      const bar = sectionId ? document.querySelector(`#RedprintwareStickyAtc-${CSS.escape(String(sectionId))}`) : null;
      setStickyButtonState(bar, false);
    });
  }

  // Keep custom Buy It Now and sticky ATC aligned with Refresh's selected variant.
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productRoot = document.querySelector(`#MainProduct-${CSS.escape(String(data?.sectionId))}`);
      productRoot?.querySelectorAll('.rpw-buy-now-button').forEach((button) => {
        button.disabled = !data?.variant?.available;
      });

      syncStickyBar(data?.sectionId, data?.html, data?.variant);
      requestStickyVisibilityUpdate();

      requestAnimationFrame(() => {
        document.querySelectorAll('.redprintware-product-pro.rpw-thumbs-left, .redprintware-product-pro.rpw-thumbs-right')
          .forEach((root) => {
            const list = root.querySelector('.thumbnail-list');
            const item = root.querySelector('.thumbnail[aria-current]')?.closest('.thumbnail-list__item');
            if (!list || !item) return;
            const itemTop = item.offsetTop;
            const itemBottom = itemTop + item.offsetHeight;
            if (itemTop < list.scrollTop) list.scrollTo({ top: itemTop });
            if (itemBottom > list.scrollTop + list.clientHeight) {
              list.scrollTo({ top: itemBottom - list.clientHeight });
            }
          });
      });
    });
  }

  requestStickyVisibilityUpdate();
})();
